import { OnboardingPayload } from './onboarding';

/**
 * 온보딩 목 데이터.
 *
 * 🔴 **핸드오프 문서(B5)의 JSON 예시와 형태가 같아야 합니다.**
 * 목이 서버보다 후하면 화면은 멀쩡해 보이고 실제 센터에서 빈칸이 뜹니다.
 * QA 가 통과합니다 — 기존 기획서 §5-④ 가 「실제로 그랬습니다」라고 적어 둔 함정입니다.
 *
 * 그래서 아직 집계 경로가 없는 값은 목에서도 **`null`** 로 둡니다.
 * 예약·식단·컨디션이 그렇습니다.
 *
 * 값은 실측(지엘핏쌍문본점 2026-08-26)에서 가져왔습니다 —
 * 수강 회원 6명, 앱 연결 4명, 수강권 6명 전원 미등록.
 */
export const mockOnboarding = (): OnboardingPayload => ({
    openedOn: '2026-08-01',

    coachCount: 2,
    coachConnectedCount: 2,
    coachesWithoutMembers: [],

    memberCount: 6,
    memberAppUnlinkedCount: 2,
    memberWithoutMembershipCount: 6,

    // 🔴 집계 경로가 아직 없습니다. 0 으로 채우면 「다 끝났습니다」가 됩니다.
    memberWithoutBookingCount: null,
    journalPct: null,
    mealLogPct: null,
    conditionCheckPct: null,

    samples: {
        appUnlinked: ['박산하', '김용식'],
        withoutMembership: ['박산하', '김용식', '허지민', '차현서', '윤진', '박인혜'],
    },
});

/** 온보딩이 끝난 센터 — 일반 브리핑으로 넘어가는지 확인할 때 씁니다 */
export const mockOnboardingFinished = (): OnboardingPayload => ({
    ...mockOnboarding(),
    memberAppUnlinkedCount: 0,
    memberWithoutMembershipCount: 0,
    coachesWithoutMembers: [],
});
